import t from '~/meta/vendorTerms/index';
import { CouplesStorefrontDetails } from '~/types/storefrontDetails';

import { Question } from '../../components/Question/Question';
import { WeddingPartyField } from '../../components/WeddingPartyField/WeddingPartyField';
import { useInquiryValues } from '../../context/InquiryContext';
import { LoadedInquiryValues } from '../../context/types';

export const getHed = ({ storefront }: { storefront: CouplesStorefrontDetails }) =>
  t(
    storefront.taxonomyKey,
    'inquiriesV2.partySize.hed',
    'How many people are in your wedding party?'
  );

export const getInstructions = ({ storefront }: { storefront: CouplesStorefrontDetails }) =>
  t(storefront.taxonomyKey, 'inquiriesV2.partySize.dek', '');

export const WeddingPartyQuestion = (): JSX.Element => {
  const { storefront } = useInquiryValues() as LoadedInquiryValues;

  return (
    <Question hed={getHed({ storefront })} instructions={getInstructions({ storefront })}>
      <WeddingPartyField />
    </Question>
  );
};
